var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.46958C0 5.20635 0.10379 4.95373 0.288854 4.76653L4.28885 0.720439C4.68028 0.324499 5.31972 0.324499 5.71115 0.720439L9.71115 4.76653C9.89621 4.95373 10 5.20635 10 5.46958V10.9989C10 11.5512 9.55229 11.9989 9 11.9989H1C0.447715 11.9989 0 11.5512 0 10.9989V5.46958Z",
    fill: "#86BC25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenHome);
export default __webpack_public_path__ + "static/media/green-home.60edbaf398c85e92a8e9eab2fa348f3c.svg";
export { ForwardRef as ReactComponent };